import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-31">
      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-32">
        <div className="flex flex-col items-center text-center" data-id="element-33">
          <FadeIn data-id="element-34">
            <span className="inline-block py-1 px-3 rounded-full bg-terracotta/10 text-terracotta text-sm font-semibold tracking-wide uppercase mb-6" data-id="element-35">
              El Método de los 15 Minutos
            </span>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-36">
            <h1 className="text-5xl md:text-6xl lg:text-7xl text-charcoal mb-6 max-w-4xl leading-[1.1]" data-id="element-37">
              HOGAR EN AUTOPILOTO
            </h1>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-38">
            <p className="text-xl md:text-2xl text-warmgray mb-10 max-w-2xl font-light leading-relaxed" data-id="element-39">
              Domina la cena y el orden al llegar a casa, incluso cuando tu
              energía está en cero.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-40">
            <Button scrollTo="pricing" className="mb-16 shadow-warm" data-id="element-41">
              ¡QUIERO MI HOGAR EN AUTOPILOTO AHORA!
            </Button>
          </FadeIn>

          <FadeIn delay={0.4} className="w-full max-w-4xl relative" data-id="element-42">
            <div className="absolute inset-0 bg-gradient-to-t from-linen via-transparent to-transparent z-10 h-full w-full pointer-events-none" data-id="element-43" />
            <img src="https://cdn.magicpatterns.com/uploads/wU2YkaFbeqjVvT5uznJEk2/heylloyd-image-1776983760438.png" alt="Hogar en Autopiloto en iPad" className="w-full h-auto rounded-xl shadow-2xl object-cover" data-id="element-44" />
          </FadeIn>
        </div>
      </div>
    </section>;
}